import dayjs, { Dayjs } from "dayjs";
import { DateInput, DatePickerInput, DateTimePicker } from '@mantine/dates';
import { Button, Group, Modal, NumberInput, TextInput, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import 'dayjs/locale/zh-tw';
import { ChatCreditKey, getGetApiAdminChatCreditKeyListByUserIdQueryKey, usePostApiAdminChatCreditKeyCreate } from "@/API";
import { DateToTimestamp, TimestampToDate } from "@/Helpers/DateHelper";
import { ConvertToTimestampInputProps } from "@/Helpers/FormHelper";

export function AddCreditKeyDialog(props: { userId: string, opened: boolean, onClose: () => void }) {
    const queryClient = useQueryClient()
    const CreateKey_Mutation = usePostApiAdminChatCreditKeyCreate()
    const [expiryTime, setExpiryTime] = useState<Date | null>(dayjs(new Date()).add(1, "month").toDate());
    const form = useForm<ChatCreditKey>({
        initialValues: {
            id: "",
            userId: props.userId,
            description: "",
            startTimestamp: DateToTimestamp(new Date()),
            endTimestamp: DateToTimestamp(dayjs().add(1, "month").toDate())
        },
        validate: {
            credit: (value) => ((value ?? 0) <= 0 ? '聊天點數必須>0' : null),
        }
    });
    useEffect(() => {
        if (props.opened) {
            form.reset()
        }
    }, [props.opened])
    return <>
        <Modal opened={props.opened} onClose={props.onClose} title="新增儲值金鑰">
            <form onSubmit={form.onSubmit(async (values) => {
                try {
                    values.totalCredit = values.credit
                    await CreateKey_Mutation.mutateAsync({
                        data: values
                    })
                    queryClient.invalidateQueries({ queryKey: getGetApiAdminChatCreditKeyListByUserIdQueryKey() })
                    notifications.show({ message: "新增成功" })
                    props.onClose()
                } catch (e) {
                    notifications.show({ message: "新增失敗", color: "red" })
                }
            })}>
                {form.getInputProps("startTime").value}
                <DateTimePicker
                    label="開始時間"
                    locale="zh-tw"
                    valueFormat="YYYY/MM/DD HH:mm"
                    {...ConvertToTimestampInputProps(form.getInputProps('startTimestamp'))}

                />
                <DateTimePicker
                    label="到期時間"
                    locale="zh-tw"
                    valueFormat="YYYY/MM/DD HH:mm"
                    {...ConvertToTimestampInputProps(form.getInputProps('endTimestamp'))}
                />
                <NumberInput
                    label="聊天點數"
                    min={0}
                    {...form.getInputProps('credit')}
                />
                <Textarea
                    label="註記"
                    rows={5}
                    {...form.getInputProps('description')}
                />
                <Group justify="flex-end" mt="md">
                    <Button type="submit">新增</Button>
                </Group>
            </form>
        </Modal>
    </>
}